module.exports = __webpack_public_path__ + "img/signup-guide-03-04.6eb9511e.png";